import React, { Fragment } from 'react'
import { Link } from 'gatsby'

class Content extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return (
            <Fragment>
                <section className="contact-us">
                    <div className="custom-container">
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <h3>Svar på de vanligaste frågorna om <br/> Albert, prenumerationer och mycket <br/> mer hittar du <Link to="/faq"> här.</Link></h3>
                             
                            <p className="desktop">Är du lärare eller annan representant från en skola och intresserade av <br/> att ligga i framkant genom att erbjuda dina elever gratis läxhjälp? <br/> Givetvis fixar vi det! Kontakta oss bara på info@hejalbert.se.</p>
                            <p className="for-mobile">Är du lärare eller annan representant från en skola och <br/> intresserade av att ligga i framkant genom att erbjuda <br/> dina elever gratis läxhjälp? Givetvis fixar vi det! <br/> Kontakta oss bara på info@hejalbert.se.</p>
    
                        </div>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="contact-tight">
                                <h2>Generella frågor</h2>
                                <a href="mailto:info@hejalbert.se">info@hejalbert.se</a>
                                <h2>Support</h2>
                                <a href="mailto:support@hejalbert.se">support@hejalbert.se</a>
                                <h2>Adress</h2>
                                <h4>Albert</h4>
                                <p>Järntorget 3 <br/> 413 04 Göteborg</p>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

export default Content;